import { UserDto } from '@marketplace-web/shared/user-data'
import { findThumbnail } from '@marketplace-web/shared/utils'
import { transformPhotoDto } from 'data/transformers/photo'

import { ProductItemUserModel } from '../types/product-item-user'

export const transformPartialUserDtoToProductItemUser = (
  user: Partial<Pick<UserDto, 'id' | 'login' | 'photo' | 'profile_url' | 'business'>>,
): ProductItemUserModel => ({
  id: user.id,
  login: user.login,
  photo: user.photo ? transformPhotoDto(user.photo) : null,
  thumbnailUrl: findThumbnail(user.photo),
  profileUrl: user.profile_url,
  isBusiness: user.business,
})
